/** GBWhatPro.org 博客首页文案（独立撰写，非其它站搬运） */
export const blogHubMeta = {
	title: 'GB WhatsApp Pro Blog – Help Articles & Guides',
	description:
		'Read GB WhatsApp Pro help articles on safety, updates, backups, features, and troubleshooting. Independent guides for Android users on GBWhatPro.org.',
	keywords: 'gb whatsapp pro blog, gb whatsapp pro help, gb whatsapp pro guides',
}

export const blogHubHero = {
	kicker: 'GBWhatPro.org · help articles only',
	h1: 'GB WhatsApp Pro Blog',
	lead:
		'Articles listed here are written for gbwhatpro.org only—account safety, troubleshooting, updates, backups, and settings for GB WhatsApp Pro on Android.',
}

export const blogHubStart = {
	h2: 'How to use this library',
	paragraphs: [
		'Each article covers one problem or setting—install errors, updates, backups, privacy, or account warnings. Scroll the list with cover previews so you know what you are opening.',
		'New to sideloading? Read the installation and safety hubs on this site first; blog posts assume you already decided to use an unofficial APK.',
	],
	links: [
		{ label: 'Help center', href: '/help/' },
		{ label: 'Download page', href: '/download/' },
		{ label: 'FAQ', href: '/faq/' },
	],
}

export const blogHubSections = {
	featuredH2: 'Start here',
	featuredLead: 'Three recent guides people open most often when something breaks or before an APK change.',
	latestH2: 'All articles',
	disclaimer:
		'Articles describe unofficial GB WhatsApp Pro builds. GBWhatPro.org is not affiliated with WhatsApp LLC or Meta Platforms, Inc.',
}
